module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-5 darker"
  }, [_c('div', {
    staticClass: "row mt-5"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mb-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        VAT ID\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoices.vatID),
      expression: "invoices.vatID"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.invoices.vatID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoices, "vatID", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mb-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 d-flex flex-row align-items-center justify-content-between"
  }, [_c('span', [_vm._v("Connect with ZRest invoice system")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "value": true,
      "sync": true,
      "labels": {
        checked: 'YES',
        unchecked: 'NO'
      }
    },
    model: {
      value: (_vm.invoices.connectZRest),
      callback: function($$v) {
        _vm.$set(_vm.invoices, "connectZRest", $$v)
      },
      expression: "invoices.connectZRest"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mb-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        API - KEY\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoices.apiKey),
      expression: "invoices.apiKey"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text",
      "disabled": !_vm.invoices.connectZRest
    },
    domProps: {
      "value": (_vm.invoices.apiKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoices, "apiKey", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('input', {
    staticClass: "btn widest ml-auto",
    attrs: {
      "type": "submit",
      "value": "Save"
    },
    on: {
      "click": _vm.save
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8 border-bottom-medium mb-4"
  }, [_c('div', {
    staticClass: "darker font-weight-600"
  }, [_vm._v("Invoice Settings")]), _vm._v(" "), _c('div', {
    staticClass: "darker fs-small"
  }, [_vm._v("VAT, System Integration, Invoice details.")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-05cad3b6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05cad3b6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/TabInvoices.vue
// module id = 2542
// module chunks = 0